import React from 'react';
import { connect } from 'react-redux';
import {
  discountsPageRequest,
  changeDateDiscounts,
  changeOutletDiscounts,
  exportDiscount,
} from 'actions/reports/sales';
import NoDataDisplay from 'components/NoDataDisplay/NoDataDisplay';
import moment from 'moment';
import { formValueSelector } from 'redux-form';
import LoadingSpinner from 'components/LoadingSpinner';
import TableScrollHorizontalVertical from 'components/TableScrollHorizontalVertical';
import { currencyFormatter } from 'utils/formatter';
import TableWithoutChild from 'components/TableReportSales/TableWithoutChild';
import * as clevertapReportsDiscounts from 'clevertap/reports/discounts';
import { getFormattedTime, getFormattedEndDate } from 'utils/hourFilter';
import { csvName } from 'utils/formatterCsvName';
import ActionBar from '../ActionBar';
import styles from './Discounts.css';
import BodyFrame from '../BodyFrame';

class Discounts extends React.Component {
  componentDidMount() {
    this.props.dispatch(discountsPageRequest());
  }

  render() {
    const {
      discounts,
      showLoadingSpinnerReport,
    } = this.props.data.reports.discounts;
    const [parentBody, childBody, childFoot] = this._formatDataForList(
      discounts
    );
    const [
      childFootResponsive,
      childBodyResponsive,
    ] = this._formatDataForListResponsive(discounts);

    return (
      <div id="reports-sales-discounts" className={styles.wrapper}>
        <ActionBar
          onChangeDate={this._onChangeDate}
          onChangeOutlet={this._onChangeOutlet}
          onExport={this._onClickExport}
        />
        <BodyFrame location={this.props.location}>
          <div
            className={`${styles.tableWrapper} discount-sales-table visible-md visible-lg`}
          >
            <LoadingSpinner showLoadingSpinner={showLoadingSpinnerReport} />
            {discounts.length > 0 && (
              <TableScrollHorizontalVertical
                accessedBy={'discount'}
                parentHeader={'Name'}
                parentBody={parentBody}
                parentFoot={'Total'}
                parentClassName={['p-header', 'p-body', 'p-foot']}
                childHeaders={[
                  'Discount Amount',
                  'Count',
                  'Gross Discount',
                  'Discount Refunded',
                  'Net Discount',
                ]}
                childBody={childBody}
                childFoot={childFoot}
                childHeaderClassName={[
                  'header-discount-amount',
                  'header-count',
                  'header-gross-discount',
                  'header-discount-refunded',
                  'header-net-discount',
                ]}
                childBodyClassName={[
                  'body-discount-amount',
                  'body-count',
                  'body-gross-discount',
                  'body-discount-refunded',
                  'body-net-discount',
                ]}
                childFootClassName={[
                  'foot-discount-amount',
                  'foot-count',
                  'foot-gross-discount',
                  'foot-discount-refunded',
                  'foot-net-discount',
                ]}
              />
            )}
            {!discounts.length && !showLoadingSpinnerReport && (
              <div className="no-data-display-container">
                <NoDataDisplay title="No Data to Display" />
              </div>
            )}
          </div>
          <div
            className={`${styles.tableWrapperResponsive} visible-xs visible-sm`}
          >
            <LoadingSpinner showLoadingSpinner={showLoadingSpinnerReport} />
            {discounts.length > 0 && (
              <TableWithoutChild
                headerBody={['Name', 'Discount Amount', 'Count']}
                childBody={childBodyResponsive}
                footBody={childFootResponsive}
                tableClass="discount-sales-table-responsive"
                headerBodyClassName={[
                  'header-name',
                  'header-discount-amount',
                  'header-count',
                ]}
                childBodyClassName={[
                  'body-name',
                  'body-discount-amount',
                  'body-count',
                ]}
                footBodyClassName={[
                  'foot-name',
                  'foot-discount-amount',
                  'foot-count',
                ]}
              />
            )}
            {!discounts.length && !showLoadingSpinnerReport && (
              <div className="no-data-display-container">
                <NoDataDisplay title="No Data to Display" />
              </div>
            )}
          </div>
        </BodyFrame>
      </div>
    );
  }

  _formatDataForList = discounts => {
    const parentBody = [];
    const childBody = [];
    const childFoot = {
      total_discount_amount: null,
      total_count: null,
      total_discount_applied: null,
      total_discount_refunded: null,
      total_net_discount: null,
    };
    discounts.map(function(discount) {
      parentBody.push(discount.name);
      childBody.push({
        amount: discount.amount,
        count: discount.count,
        discount_applied:
          Number.isFinite(-discount.discount_applied) &&
          currencyFormatter(-discount.discount_applied),
        refund: discount.refund ? currencyFormatter(discount.refund) : '',
        net_discount:
          Number.isFinite(-discount.net_discount) &&
          currencyFormatter(-discount.net_discount),
      });
      childFoot.total_count = childFoot.total_count + discount.count;
      childFoot.total_discount_applied =
        childFoot.total_discount_applied +
        Math.round(discount.discount_applied);
      childFoot.total_discount_refunded =
        childFoot.total_discount_refunded + Math.round(discount.refund);
      childFoot.total_net_discount =
        childFoot.total_net_discount + Math.round(discount.net_discount);
    });

    childFoot.total_discount_applied =
      Number.isFinite(-childFoot.total_discount_applied) &&
      currencyFormatter(-childFoot.total_discount_applied);

    childFoot.total_discount_refunded =
      childFoot.total_discount_refunded === 0
        ? null
        : childFoot.total_discount_refunded;
    childFoot.total_discount_refunded =
      Number.isFinite(childFoot.total_discount_refunded) &&
      currencyFormatter(childFoot.total_discount_refunded);

    childFoot.total_net_discount =
      childFoot.total_net_discount === 0 ? null : childFoot.total_net_discount;
    childFoot.total_net_discount =
      Number.isFinite(-childFoot.total_net_discount) &&
      currencyFormatter(-childFoot.total_net_discount);

    return [parentBody, childBody, childFoot];
  };

  _formatDataForListResponsive = discounts => {
    const childBody = [];
    const footBody = {
      name: 'Total',
      total_discount_amount: null,
      total_discount_count: null,
    };
    if (discounts) {
      discounts.map(function(discount) {
        childBody.push({
          name: discount.name,
          amount:
            discount.discount_type &&
            discount.discount_type.toLowerCase() === 'cash'
              ? `Rp. ${Math.round(discount.amount)}`
              : `${discount.amount}%`,
          count: discount.count,
        });
        footBody.total_discount_count =
          footBody.total_discount_count + discount.count;
      });
    }
    return [footBody, childBody];
  };

  _onChangeOutlet = (outletIds = []) => {
    const {
      startDate,
      endDate,
      startHour,
      endHour,
      allDay,
    } = this.props.search.date;
    const { formattedStart, formattedEnd } = getFormattedTime(
      startDate,
      endDate,
      startHour,
      endHour,
      allDay
    );
    this.props.dispatch(
      changeOutletDiscounts({
        outletIds,
        startDate: formattedStart,
        endDate: formattedEnd,
      })
    );
  };

  _onChangeDate = ({ startDate, endDate, startHour, endHour, allDay }) => {
    const { outlet } = this.props.search;
    const { formattedStart, formattedEnd } = getFormattedTime(
      startDate,
      endDate,
      startHour,
      endHour,
      allDay
    );
    this.props.dispatch(
      changeDateDiscounts(formattedStart, formattedEnd, outlet)
    );
  };

  _onClickExport = () => {
    const {
      startDate,
      endDate,
      startHour,
      endHour,
      allDay,
    } = this.props.search.date;
    const { outlet } = this.props.search;
    const { outlets } = this.props;
    const { formattedStart, formattedEnd } = getFormattedTime(
      startDate,
      endDate,
      startHour,
      endHour,
      allDay
    );
    const filename = csvName(
      moment(formattedStart),
      moment(formattedEnd),
      'Report Discounts',
      outlet,
      outlets,
      allDay
    );
    clevertapReportsDiscounts.reportsDiscountExport({
      outletIds: outlet,
      startDate: formattedStart,
      endDate: formattedEnd,
    });
    const query = {
      start: formattedStart,
      end: getFormattedEndDate(formattedEnd),
      outletIds: outlet,
      filename,
    };
    this.props.dispatch(exportDiscount(query, filename));
  };
}

const selector = formValueSelector('search');

function select(state) {
  return {
    outlets: state.actionBar.outlets,
    search: {
      outlet: selector(state, 'outlet'),
      date: selector(state, 'date'),
    },
    data: {
      reports: {
        discounts: state.reports.discounts,
      },
      outlet: state.outlet,
    },
  };
}

export default connect(select)(Discounts);
